<template>
    <modal ref="crearPedido" v-loading="loading" titulo="Crear Pedido" tamano="modal-lg" icon="Filledoutline" @guardar="crear_pedido">
        <div class="row my-3 text-muted f-14 justify-center text-center px-3">
            <el-radio-group v-model="tipoCliente">
                <el-radio :label="1">
                    Cliente Registrado
                </el-radio>
                <el-radio :label="0">
                    Cliente Nuevo
                </el-radio>
            </el-radio-group>
        </div>
        <ValidationObserver v-if="tipoCliente == 1" ref="form1" class="row mx-0 justify-center">
            <div class="col-7  justify-center">
                <ValidationProvider v-slot="{errors}" class="w-100 col-5" rules="required" name="Cliente">
                    <p class="ml-2">Cliente</p>
                    <el-select v-model="model.cliente" class="w-100" size="small" filterable placeholder="Seleccionar" @change="set_cliente">
                        <el-option
                        v-for="item in opciones"
                        :key="item.id_user"
                        :label="item.nombre"
                        :value="item.id_user"
                        />
                    </el-select>
                    <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                </ValidationProvider>
                
            </div>
            <div class="col-3 justify-center">
                <ValidationProvider v-slot="{errors}" class="w-100 col-5" rules="required" name="cedis">
                    <p class="ml-2">Cedis</p>
                    <el-select v-model="model.id_cedis" class="w-100" size="small" filterable placeholder="Seleccionar">
                        <el-option
                        v-for="item in cedis.filter(item => item.id != 0)"
                        :key="item.id"
                        :label="item.nombre"
                        :value="item.id"
                        />
                    </el-select>
                    <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                </ValidationProvider>
            </div>
            <div class="col-10 mx-auto justify-center">
                <p class="ml-2">Direccion</p>
                <ValidationProvider v-slot="{errors}" class="w-100" rules="required" name="direccion">
                    <div class="d-middle">
                        <el-select v-model="value_direccion" class="w-100" size="small" filterable placeholder="Seleccionar" @change="set_direccion">
                            <el-option
                            v-for="item in direcciones"
                            :key="item.id"
                            :label="item.direccion"
                            :value="item.id"
                            />
                        </el-select>
                    </div>
                    <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                </ValidationProvider>
            </div>
            <div class="row w-100 f-14 mt-4 mx-0 justify-center">
                <div class="col-4 mx-0">
                    <p class="ml-2">Fecha de Entrega</p>
                    <ValidationProvider v-slot="{errors}" class="w-100 col-10" rules="required" name="fecha">
                        <el-date-picker
                        v-model="model.entrega_fecha"
                        type="date"
                        size="small"
                        placeholder="Fecha"
                        value-format="yyyy-MM-dd"
                        value="yyyy-MM-dd"
                        :clearable="false"
                        :picker-options="pickerOptions"
                        @change="set_franja"
                        />
                        <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                    </ValidationProvider>
                </div>
                <div class="col-3 mx-0">
                    <p class="ml-2">Hora de Entrega</p>
                    <ValidationProvider v-slot="{errors}" class="w-100 col-10" rules="required" name="hora">
                        <el-select v-model="model.entrega_horario" size="small" placeholder="Horario">
                            <el-option
                            v-for="item in horarios"
                            :key="item.hora"
                            :label="item.horario"
                            :value="item.hora"
                            :disabled="item.disable"
                            />
                        </el-select>
                        <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                    </ValidationProvider>
                </div>
                <div class="col-3 mx-0 w-100">
                    <p class="ml-2">Valor domicilio</p>
                    <div class="d-middle">
                        <money v-model="model.domicilio" class="input-money w-100" v-bind="money" />
                    </div>
                </div>
            </div>
            <div class="col-10  mx-auto my-3">
                <p class="ml-2">Instrucciones</p>
                <el-input
                v-model="model.instrucciones"
                type="textarea"
                rows="4"
                placeholder="Digite la instrucciones de entrega"
                maxlength="1000"
                show-word-limit
                />
            </div>
        </ValidationObserver>
        <ValidationObserver v-if="tipoCliente == 0"  ref="form2" class="row mx-0 justify-center">
            <div class="row mx-0 mt-3 justify-center"   >
                    <div class="col-6 my-2">
                        <ValidationProvider v-slot="{errors}" rules="required|max:40" name="nombre">
                            <label class="f-15 pl-3"> Nombre </label>
                            <el-input v-model="model.nombre" size="small" class="w-100" maxlength="40" show-word-limit />
                            <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-4 my-2">
                        <ValidationProvider v-slot="{errors}" rules="required|numeric" name="telefono">
                            <label class="f-15 pl-3"> Telefono </label>
                            <el-input v-model="model.telefono" size="small" class="w-100" maxlength="10" />
                            <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-6 my-2">
                        <ValidationProvider v-slot="{errors}" rules="numeric" name="identificacion">
                            <label class="f-15 pl-3"> # Identificacion </label>
                            <el-input v-model="model.identificacion" size="small" class="w-100" maxlength="20" />
                            <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-4 px-0 my-2">
                        <ValidationProvider v-slot="{errors}"  rules="required" name="cedis">
                            <label class="f-15 pl-3">Cedis</label>
                            <el-select v-model="model.id_cedis" class="w-100" size="small" filterable placeholder="Seleccionar">
                                <el-option
                                v-for="item in cedis.filter(item => item.id != 0)"
                                :key="item.id"
                                :label="item.nombre"
                                :value="item.id"
                                />
                            </el-select>
                            <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                        </ValidationProvider>
                    </div>

                    <div class="row justify-content-center w-100">

                        <div class="col-4 my-2 ">
                            <ValidationProvider v-slot="{errors}" rules="required" name="país">
                                <label class="f-15 pl-3">Pais</label>
                                <el-select v-model="model.idm_pais" size="small" class="w-100" filterable @change="consultarEstados">
                                    <el-option
                                    v-for="item in paises"
                                    :key="item.id"
                                    :label="item.nombre"
                                    :value="item.id"
                                    />
                                </el-select>
                                <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                            </ValidationProvider>
                        </div>
                        <div class="col-3 my-2 px-0">
                            <ValidationProvider v-slot="{errors}" rules="required" name="estado">
                                <label class="f-15 pl-3">Estado</label>
                                <el-select v-model="model.idm_estado" size="small" class="w-100" filterable @change="consultarCiudades">
                                    <el-option
                                    v-for="item in estados"
                                    :key="item.id"
                                    :label="item.nombre"
                                    :value="item.id"
                                    />
                                </el-select>
                                <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                            </ValidationProvider>
                        </div>
                        <div class="col-3 my-2 px-0">
                            <ValidationProvider v-slot="{errors}" rules="required" name="ciudad">
                                <label class="f-15 pl-3">Ciudad</label>
                                <el-select v-model="model.idm_ciudad" size="small" class="col" filterable>
                                    <el-option
                                    v-for="item in ciudades"
                                    :key="item.id"
                                    :label="item.nombre"
                                    :value="item.id"
                                    />
                                </el-select>
                                <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-10 my-2">
                        <ValidationProvider v-slot="{errors}" rules="required|max:70" name="dirección">
                            <label class="f-15 pl-3"> Dirección </label>
                            <el-input v-model="model.direccion" size="small" class="w-100" maxlength="70" show-word-limit  @change="buscarDireccion" />
                            <span class="text-danger w-100 f-11"> {{ errors[0] }} </span>
                        </ValidationProvider>
                    </div>
                    <div class="col-10 my-2">
                        <mapa ref="mapaPeq" class="br-12" :coordenadas="coordenadas" icono="marker_cliente.svg" :buscar="getDireccionCon" @actualizar="actualizarCoordenadas" />
                        <p class="f-13 mt-2 text-gris2 cr-pointer" @click="abrirModalMapa()">
                            Haga click aquí, para seleccionar la ubicación exacta
                        </p>
                    </div>



                    <div class="col-4 mx-0">
                        <ValidationProvider v-slot="{errors}" rules="required" name="fecha">
                            <label class="f-15 pl-3">Fecha de Entrega</label>
                            <el-date-picker
                            v-model="model.entrega_fecha"
                            type="date"
                            size="small"
                            placeholder="Fecha"
                            value-format="yyyy-MM-dd"
                            value="yyyy-MM-dd"
                            :clearable="false"
                            :picker-options="pickerOptions"
                            @change="set_franja"
                            />
                            <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                        </ValidationProvider>
                    </div>
                    <div class="col-3 mx-0">
                        <ValidationProvider v-slot="{errors}"  rules="required" name="hora">
                            <label class="f-15 pl-3">Hora de Entrega</label>
                            <el-select v-model="model.entrega_horario" size="small" placeholder="Horario">
                                <el-option
                                v-for="item in horarios"
                                :key="item.hora"
                                :label="item.horario"
                                :value="item.hora"
                                :disabled="item.disable"
                                />
                            </el-select>
                            <p class="text-danger w-100 f-11"> {{ errors[0] }} </p>
                        </ValidationProvider>
                    </div>
                    <div class="col-3 mx-0">
                        <p class="ml-2">Valor domicilio</p>
                        <div class="d-middle">
                            <money v-model="model.domicilio" class="input-money w-100" v-bind="money" />
                        </div>
                    </div>
                    <div class="col-10 ">
                        <p class="ml-2">Instrucciones</p>
                        <el-input
                        v-model="model.instrucciones"
                        type="textarea"
                        rows="4"
                        placeholder="Digite la instrucciones de entrega"
                        maxlength="1000"
                        show-word-limit
                        />
                    </div>
                </div>
        </ValidationObserver>   
        <mapa-google-modal
        ref="modalMapaGoogle"
        busqueda
        titulo="Seleccionar Ubicación"
        icono-central="/img/icons/marker_cliente.svg"
        :buscar="getDireccionCon"
        :coordenadas-entrada="coordenadas"
        @actualizar="actualizarCoordenadasCiudad"
        />  
    </modal>
</template>

<script>
import {Money} from 'v-money'
import {mapGetters} from 'vuex'
import moment from 'moment'
import Pedidos from '~/services/pedidos/pedidos-tienda'
import PedidosAdmin from '~/services/pedidos/pedidos-admin'
import Localizaciones from "~/services/proyectos/localizaciones";
export default {
    components:{
        Money,
    },
    data(){
        let that = this;
        return{
            tipoCliente:1,
            pickerOptions: {
                disabledDate(time){
                    return time.getTime() < that.fechaMinima
                }
            },
            fechaMinima:moment(),
            money: {
                thousands: '.',
                prefix: '$ ',
                precision: 0,
                masked: false
            },
            value_direccion:'',
            loading:false,
            opciones:[],
            horarios:[],
            direcciones:[],
            cliente:{},
            model:{
                cliente:'',
                nombre:'',
                telefono:'',
                identificacion:'',
                direccion:'',
                longitud:0,
                latitud:0,
                domicilio:0,
                instrucciones:'',
                entrega_fecha:'',
                entrega_horario:'',
                idm_ciudad: null
            },
            coordenadas: {
                lat: 7.12539,
                lng: -73.1198,
            },
            paises: [],
            estados: [],
            ciudades: [],
        }
    },  
    computed:{
        ...mapGetters({
            cedis:'cedis/cedis'
        }),
        getDireccionCon(){
            const { ciudad = '' } = this.ciudades.find(x => x.id === this.model.idm_ciudad) || {};
            const { nombre: pais = '' } = this.paises.find(x => x.id === this.model.idm_pais) || {};
            return [this.model.direccion, ciudad, pais].filter(el => el).join(',')
        },
    },
    methods: {
        toggle(){
            this.model.cliente = ''
            this.model.instrucciones = ''
            this.model.entrega_fecha = '',
            this.model.entrega_horario = ''
            this.cliente = {}
            this.select_clientes()
            this.consultarPaises()
            this.$refs.crearPedido.toggle()
        },
        async select_clientes(){
            const {data} = await Pedidos.select_clientes_general()
            this.opciones = data.clientes
        },
        async crear_pedido(){
            try {
                this.loading = true
                let valid  = false
                if(this.tipoCliente == 1){
                    valid = await this.$refs.form1.validate()
                }else{
                    valid = await this.$refs.form2.validate()
                }
                if(valid){
                    this.model.tipo = this.tipoCliente
                    const {data} = await Pedidos.crear_pedido_cliente(this.model)
                    this.notificacion('Éxito','Pedido almacenado correctamente','success')
                    this.$router.push({params:{id_pedido:data.id}})
                    this.$refs.crearPedido.toggle()
                }
            } catch (e){
                this.error_catch(e)
            } finally {
                this.loading = false
            }
        },
        set_cliente(id){
            this.cliente = this.opciones.find(o=>o.id_user === id)
            this.value_direccion = ''
            this.direcciones = [],
            this.model.direccion = ''
            this.model.longitud = 0
            this.model.latitud = 0
            this.model.domicilio = 0
            this.id_tienda = this.cliente.id_tienda
            this.get_direcciones(id)
        },
        async get_direcciones(id_user){
            const {data} = await Pedidos.get_direcciones(id_user)
            this.direcciones = [...data.direcciones]

            if(data.length){
                this.model.direccion = data.direcciones[0].direccion
            }
        },
        set_direccion(id){
            let direccion = this.direcciones.find(o=>o.id === id)
            this.model.direccion = direccion.direccion
            this.model.longitud = direccion.longitud
            this.model.latitud = direccion.latitud

        },
        async set_franja(fecha){
            try {
                let id_cedis = this.model.id_cedis
                if(!id_cedis) return
                const {data} = await PedidosAdmin.setFranjasHorarios(id_cedis,fecha, true)
                this.horarios = data?.data
                this.model.entrega_horario = ""

            } catch (e){
                this.error_catch(e)
            }
        },
        buscarDireccion(){
            this.$refs.mapaPeq.accionBuscar();
        },
        async consultarPaises(){
            try {
                const {data} = await Localizaciones.consultarPaises(this.$usuario.proyecto.id)
                this.paises = data.data
            } catch (e){
                this.error_catch(e)
            }
        },
        async consultarEstados(){
            try {
                this.model.idm_estado = null
                this.model.idm_ciudad = null
                this.estados = []
                this.ciudades = []
                const {data} = await Localizaciones.consultarEstados({
                    proyecto: this.$usuario.proyecto.id,
                    pais: this.model.idm_pais
                })

                this.estados = data.data
            } catch (e){
                this.error_catch(e)
            }
        },
        async consultarCiudades(){
            try {
                this.model.idm_ciudad = null
                this.ciudades = []
                const {data} = await Localizaciones.consultarCiudades({
                    proyecto: this.$usuario.proyecto.id,
                    estado: this.model.idm_estado
                })
                this.model.idm_ciudad = null
                this.ciudades = data.data
            } catch (e){
                this.error_catch(e)
            }
        },

        actualizarCoordenadas({ latitud, longitud }){
            this.model.latitud = latitud
            this.model.longitud = longitud
            
            this.coordenadas.lat = latitud
            this.coordenadas.lng = longitud
        },
        abrirModalMapa(){
            this.$refs.modalMapaGoogle.toggle()
        },
        actualizarCoordenadasCiudad({ latitud, longitud }){
            this.model.latitud = latitud
            this.model.longitud = longitud
            this.coordenadas.lat = +this.model.latitud
            this.coordenadas.lng = +this.model.longitud
            this.$refs.mapaPeq.setPosition()
        },
    }
}
</script>

<style lang="css" scoped>
.card-prod{
    width: 330px;
    display: flex;
}
.text-aqua{
    color: #03D6BC;
}
</style>
